var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.26316 0L0 4.28572V19.7143H5.11579V24L9.37895 19.7143H12.7895L20.4631 12V0H4.26316ZM18.7579 11.1429L15.3474 14.5715H11.9368L8.95264 17.5715V14.5715H5.11579V1.71428H18.7579V11.1429ZM16.2 4.71428H14.4947V9.85715H16.2V4.71428ZM11.5105 4.71428H9.80526V9.85715H11.5105V4.71428Z",
    fill: "#868B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAa);
export default __webpack_public_path__ + "static/media/aa.57b1a3b2454f169fb1a97357c8e98577.svg";
export { ForwardRef as ReactComponent };